
import {
  defineComponent,
} from 'vue';
import Expand from '@/components/Expand.vue';
import { formatNumber } from '@/helpers';

export default defineComponent({
  components: {
    Expand,
  },

  props: {
    options: {
      type: Object,
      required: true,
    },
  },

  setup() {
    return {
      formatNumber,
    };
  },
});
